<template>
    <div class="flex flex-column gap-2 w-full md:w-14rem">
        <label for="procedure" class="font-bold">Operator: *</label>
        <Dropdown
            id="operator"
            v-model="selectedOperator"
            :options="props.operators"
            optionLabel="name"
            optionValue="value"
            placeholder="Select an operator"
            class="w-full mr-2"
            :class="{ 'p-invalid': props.isInvalid }"
            showClear
            @change="emit('update:modelValue', selectedOperator)"
        />
        <small v-if="props.isInvalid">Operator is mandatory</small>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
    },
    operators: {
        type: Array,
    },
    isInvalid: {
        type: Boolean,
    },
});
const selectedOperator = ref(null);

onMounted(() => {
    if (props.modelValue) {
        selectedOperator.value = props.modelValue;
    }
});
</script>
